import React from 'react';
import SyncDocumentsContainer from './SyncUsersContainer';

class SyncDocumentsScreen extends React.Component {

    public render() {
        return <SyncDocumentsContainer />
    }

}

export default SyncDocumentsScreen;